import { render } from "./CensusTrendTab.vue?vue&type=template&id=22d56af2&scoped=true&ts=true"
import script from "./CensusTrendTab.vue?vue&type=script&lang=ts"
export * from "./CensusTrendTab.vue?vue&type=script&lang=ts"

import "./CensusTrendTab.vue?vue&type=style&index=0&id=22d56af2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22d56af2"]])

export default __exports__